import TableRow from '@material-ui/core/TableRow';
import * as React from 'react';
import { ISearchResult } from '../SearchBar';
import { ITableHeader } from '../SmartTable';
import SmartTableCell from './SmartTableCell';

interface ISmartTableRow<T> {
  headers: Array<ITableHeader<T>>
  content: ISearchResult<T>
  color: string
}

export default class SmartTableRow<T> extends React.PureComponent<ISmartTableRow<T>, {}> {
  public render() {
    const {
      headers,
      content,
      color,
    } = this.props;
    return (
      <TableRow
        style={content.show ? { backgroundColor: color } : {display: 'none'}}>
        {headers.map((header: ITableHeader<T>, i: number) =>
          <SmartTableCell key={i} item={content.item} header={header}/>
        )}
      </TableRow>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/smartTable/SmartTableRow.tsx